import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header d-flex justify-content-between" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 mb-3" }
const _hoisted_11 = { class: "form-floating" }
const _hoisted_12 = ["disabled", "readonly"]
const _hoisted_13 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_14 = { class: "form-floating" }
const _hoisted_15 = ["disabled", "readonly"]
const _hoisted_16 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_17 = { class: "form-floating" }
const _hoisted_18 = ["disabled", "readonly"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = ["disabled", "readonly"]
const _hoisted_23 = ["disabled", "readonly"]
const _hoisted_24 = ["disabled", "readonly"]
const _hoisted_25 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_26 = { class: "form-floating" }
const _hoisted_27 = ["disabled", "readonly"]
const _hoisted_28 = { class: "row d-none" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "form-floating" }
const _hoisted_31 = ["disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "card-title mb-0" }, [
          _createElementVNode("i", { class: "fas fa-user-circle fa-fw me-2" }),
          _createElementVNode("span", null, "Información Personal")
        ], -1)),
        _createElementVNode("div", null, [
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
                  class: "btn btn-sm btn-outline-danger me-2"
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                  _createTextVNode("Cancelar ", -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                  disabled: _ctx.saving,
                  class: "btn btn-sm btn-outline-success"
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-save fa-fw me-1" }, null, -1)),
                  _cache[13] || (_cache[13] = _createTextVNode("Guardar ", -1)),
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit())),
                  class: "btn btn-sm btn-outline-secondary"
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "fas fa-pen fa-fw" }, null, -1)
                ]))])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control fs-3 fw-bold text-center", _ctx.readOnlyClasses]),
                id: "names",
                ref: "names",
                placeholder: "Nombre(s)",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localPersonalInfo.names) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_12), [
                [_vModelText, _ctx.localPersonalInfo.names]
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("label", {
                for: "names",
                class: "opacity-100"
              }, "Nombre(s)", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control fs-3 fw-bold text-center", _ctx.readOnlyClasses]),
                id: "lastName",
                placeholder: "Apellido Paterno",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localPersonalInfo.lastName) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_15), [
                [_vModelText, _ctx.localPersonalInfo.lastName]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "lastName",
                class: "opacity-100"
              }, "Apellido Paterno", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control fs-3 fw-bold text-center", _ctx.readOnlyClasses]),
                id: "motherSurname",
                placeholder: "Apellido Materno",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localPersonalInfo.motherLastname) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_18), [
                [_vModelText, _ctx.localPersonalInfo.motherLastname]
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                for: "motherSurname",
                class: "opacity-100"
              }, " Apellido Materno ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "gender",
                id: "male",
                autocomplete: "off",
                value: "male",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localPersonalInfo.gender) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 8, _hoisted_22), [
                [_vModelRadio, _ctx.localPersonalInfo.gender]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["btn btn-outline-info rounded-start py-2 col", { 'opacity-100': _ctx.localPersonalInfo.gender == 'male' }]),
                for: "male"
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "fas fa-male fa-fw" }, null, -1),
                _createElementVNode("div", { class: "lh-1 text-truncate" }, " Masculino ", -1)
              ]))], 2),
              (_ctx.editMode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-outline-secondary px-0 col-2",
                    type: "button",
                    id: "clear-gender",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.localPersonalInfo.gender = '')),
                    disabled: !_ctx.editMode,
                    readonly: !_ctx.editMode
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("i", { class: "far fa-times-circle fa-fw" }, null, -1)
                  ]))], 8, _hoisted_23))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "gender",
                id: "female",
                autocomplete: "off",
                value: "female",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localPersonalInfo.gender) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 8, _hoisted_24), [
                [_vModelRadio, _ctx.localPersonalInfo.gender]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["btn btn-outline-pink py-2 col", { 'opacity-100': _ctx.localPersonalInfo.gender == 'female' }]),
                for: "female"
              }, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("i", { class: "fas fa-female fa-fw ms-1 mb-0" }, null, -1),
                _createElementVNode("div", { class: "lh-1 text-truncate" }, " Femenino ", -1)
              ]))], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                id: "dateOfBirth",
                placeholder: "Fecha de Nacimiento",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localPersonalInfo.dateOfBirth) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_27), [
                [_vModelText, _ctx.localPersonalInfo.dateOfBirth]
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("label", {
                for: "dateOfBirth",
                class: "opacity-100"
              }, "Fecha de Nacimiento", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                id: "curp",
                placeholder: "CURP",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localPersonalInfo.curp) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_31), [
                [_vModelText, _ctx.localPersonalInfo.curp]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                for: "curp",
                class: "opacity-100"
              }, "CURP", -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}